import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import type { AuditEvent } from '../lib/types.js';

export function AuditPage() {
  const query = useQuery({
    queryKey: ['audit'],
    queryFn: () => api.get<AuditEvent[]>('/audit?pageSize=100'),
  });

  return (
    <section>
      <h1>Audit</h1>
      <p className="muted">Append-only record of every state change.</p>
      {query.data && query.data.data.length === 0 && <p className="muted">No events yet.</p>}
      {query.data && query.data.data.length > 0 && (
        <table className="data-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Entity</th>
            </tr>
          </thead>
          <tbody>
            {query.data.data.map((e) => (
              <tr key={e._id}>
                <td>{new Date(e.occurredAt).toLocaleString()}</td>
                <td>{e.actorType}</td>
                <td>
                  <code>{e.action}</code>
                </td>
                <td>
                  {e.entityType}
                  {e.entityId ? `:${e.entityId.slice(-6)}` : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
